/* eslint-disable no-unused-vars */
/**
 * © [2024] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React from 'react';

const PrivacyPolicyComponent = () => {
  return (
    <div className="v1811_831">
      <div className="v1811_947" />
      <div className="v1811_989" />
      <div className="v1811_990" />
      <span className="v1811_991">Privacy Policy</span>
      <div className="row mt-2" />
      <div className="row mt-2" />
      <div className="row mt-5">
        Welcome to the Conduent MMIS Suite, where members, physicians,
        pharmacists and other health care providers may obtain information about
        the Medicaid Program. This web site is designed to make it easier for
        you to interact with Medicaid program. Like all online resources, we
        recognize that visitors to this web site are concerned about their
        privacy.
      </div>
      <div className="row mt-3">
        The Conduent MMIS Suite discloses personally identifiable information
        only to authorized members or their representatives, authorized agency
        staff, and authorized providers contracted to provide care to members.
      </div>
      <div className="row mt-3">
        The Conduent MMIS Suite recognizes that personally identifiable
        information collected by the State should be used only for the purpose
        for which it is collected. Except as authorized by law, such information
        will not be disclosed to other persons or organizations. Therefore, it
        is the policy of the Conduent MMIS Suite that all personally
        identifiable information collected by state government Web sites shall
        be subject to the following principles:
      </div>
      <div className="row mt-3">
        <ul>
          <li>
            Electronic information - information collected and held
            electronically shall be afforded the same protection as
            non-electronic information;
          </li>
          <li>
            Collection of personal information - the collection of personal
            information shall be limited to and consistent with the requirements
            of the government program or activity;
          </li>
          <li>
            Use of personal information - individuals shall be informed as to
            why information is being collected and how it will be used;
          </li>
          <li>
            Disclosure of personal information - disclosure of information shall
            be limited to the purpose for which it was collected unless
            otherwise authorized by law; when practical and provided by law,
            information may be obtained from other government entities;
          </li>
          <li>
            Access to personal information - individuals shall be allowed a
            reasonable opportunity to obtain access to their personal
            information and to ensure that it is correct; and
          </li>
          <li>
            Security precautions - reasonable precautions shall be taken to
            ensure the security of personal information.
          </li>
        </ul>
      </div>
      <div className="row mt-2">
        Please click one of the following links to view the privacy information.
      </div>
      <div className="row mt-1">
        <div className="col-6">
          <ul>
            <li>
              <span style={{ color: '#004A99' }}>
                {' '}
                Personally Identifiable Information
              </span>
            </li>
            <li>
              {' '}
              <span style={{ color: '#004A99' }}>
                {' '}
                Information Voluntarily Provided By You
              </span>
            </li>
            <li>
              {' '}
              <span style={{ color: '#004A99' }}> Registration</span>
            </li>
            <li>
              {' '}
              <span style={{ color: '#004A99' }}> Authentication</span>
            </li>
          </ul>
        </div>
        <div className="col-6">
          <ul>
            <li>
              {' '}
              <span style={{ color: '#004A99' }}> Security</span>
            </li>
            <li>
              {' '}
              <span style={{ color: '#004A99' }}> Links Disclaimer</span>
            </li>
            <li>
              {' '}
              <span style={{ color: '#004A99' }}> Contact Information</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="row mt-3">
        <span>
          <strong>Personally Identifiable Information.</strong> The term
          "personally identifiable information" includes health information and
          any other information that could reasonably be used to identify you,
          including your name, address, telephone number, e-mail address, Social
          Security number, Medicaid ID number, Provider ID number, birth date or
          any combination of information that could be used to identify you.
        </span>
      </div>
      <div className="row mt-3">
        <span>
          <strong>Information Voluntarily Provided By You.</strong> This web
          site collects voluntary information from you in three different ways:
          through e-mails, a registration feature and an authentication feature.
        </span>
      </div>
      <div className="row mt-3">
        <span>
          <strong>Registration.</strong> In order to engage in certain online
          transactions and access restricted online information, providers will
          be required to register with the portal by submitting your SSN/FEIN
          and Medicaid Provider Number as well as some additional demographic
          information about your organization administrator.
        </span>
      </div>
      <div className="row mt-3">
        <span>
          <strong>Authentication.</strong> The authentication method used for
          granting authorized users access to secure content requires authorized
          Members to use their Member ID and Personal Identification Number
          (PIN) and all other authorized users to use their User ID and
          password.
        </span>
      </div>
      <div className="row mt-3">
        This website does not use "cookies". However, the site uses temporary
        session cookies to allow users to interact with the portal and to use
        online features. Session cookies do not allow us to personally identify
        a user. They are stored only in memory and are deleted when the user's
        browser is shut down.
      </div>
      <div className="row mt-3">
        This site does collect and indefinitely store your Internet Protocol
        (IP) address, (which does not identify you as an individual), as well as
        information about the date and time of your visit, whether a file you
        have requested exists, and how many bytes of information were
        transmitted to you over the Web from this site. We use your IP address
        to assess the frequency of visits to this site and the popularity of its
        various pages and functions. We will not attempt to match any personally
        identifiable information that you provide to us with your IP address,
        unless required to do so in conjuction with a criminal or civil
        investigation.
      </div>
      <div className="row mt-3">
        <span>
          <strong>Security.</strong> The managers of this web site have taken
          reasonable steps to safeguard the integrity of the telecommunications
          and computing infrastructure, including but not limited to
          authentication, monitoring, auditing, and encryption. These steps
          should not be constructed in any way as giving business, legal or
          other advice, or warranting as fail proof, the security of information
          provided via this web site.
        </span>
      </div>
      <div className="row mt-3">
        <span>
          <strong>Links Disclaimer.</strong> In order to provide visitors with
          certain information, this website provides links to local,
          other-state, and federal government agencies, and web sites of other
          organizations. A link does not constitute an endorsement of the
          content, viewpoint, accuracy, opinions, policies, products, services
          or accessibility of that web site. Once you link to another web site
          from this portal, you are subject to the terms and conditions of that
          web site, including, but not limited to, its privacy policy and this
          Privacy Notice no longer applies.
        </span>
      </div>
      <div className="row mt-3">
        <span>
          <strong>Contact Information.</strong> For questions regarding this
          privacy notice, please contact: <br />
          Conduent Privacy Officer <br />
          John Folkerts <br />
          Mail Stop XRX2-8A <br />
          100 Clinton Avenue <br />
          Rochester NY, 14644
        </span>
      </div>
      <span className="v1811_997">Privacy Statement</span>
    </div>
  );
};
export default PrivacyPolicyComponent;
